var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.book &&
    (!_vm.userSettings.settings.showPagePreview ||
      _vm.userSettings.settings.showPagePreview == 'on')
  )?_c('div',{directives:[{name:"zindex",rawName:"v-zindex"},{name:"body",rawName:"v-body"}],ref:"container",staticClass:"header-container",style:({ width: _vm.previewPageSize })},[_c('headerItem',{attrs:{"currentHeaderData":_vm.currentHeaderData,"book":_vm.book,"full":_vm.full ||
      !_vm.userSettings.settings.pagePreviewType ||
      _vm.userSettings.settings.pagePreviewType == 'full',"byPos":_vm.byPos},on:{"setHeight":_vm.setHeight,"setLocation":_vm.setHeaderLocation}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }